import { useState } from "react";
import axiosInstance from "../api/axios";
import axios from "axios";
import { useDispatch } from "react-redux";
import { setCredentials } from "../store/api/authSlice";
import useAccount from "./useAccount";
import { RECAPTCHA_SITE_KEY } from "../utils/helpers";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../constants/routes";

interface LoginCredentials {
  emailOrPhone: string;
}

interface LoginCode {
  code: string;
  isMobile: boolean;
}

interface LoginResponse {
  data: {
    token: {
      access: string;
      refresh: string;
    };
  };
}

export const useLogin = () => {
  const [error, setError] = useState<string>("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { getAccountDetails } = useAccount();

  const loginStepOne = async ({ emailOrPhone }: LoginCredentials) => {
    if (!window.grecaptcha || !window.grecaptcha.enterprise) {
      return;
    }

    window.grecaptcha.enterprise.ready(async () => {
      try {
        const token = await window.grecaptcha.enterprise.execute(RECAPTCHA_SITE_KEY, { action: "submit" });
        console.log("Получен reCAPTCHA token:", token);

        localStorage.setItem("contact", emailOrPhone);
        await axiosInstance.post<LoginResponse>("login/", {
          "g-recaptcha-response": token,
          email: emailOrPhone,
        });

        setError("");
      } catch (err: any) {
        if (axios.isAxiosError(err) && err.response?.data) {
          setError(err?.response.data);
        } else {
          setError(err.message as any);
        }
      }
    });
  };

  const loginStepTwo = async ({ code, isMobile }: LoginCode) => {
    try {
      const response = await axiosInstance.post<LoginResponse>("validate-login/", {
        otp: code,
        email: localStorage.getItem("contact"),
      });

      // @ts-ignore
      localStorage.setItem("accessToken", response.data.token.access); // @ts-ignore
      localStorage.setItem("refreshToken", response.data.token.refresh); // @ts-ignore
      dispatch(setCredentials({ token: response.data.token.access }));
      await getAccountDetails();
      setError("");

      if (isMobile) {
        navigate(ROUTES.FOR_YOU);
        return;
      }

      navigate(-2);
    } catch (err: any) {
      if (axios.isAxiosError(err) && err.response?.data) {
        setError(err?.response.data);
      } else {
        setError(err.message as any);
      }
    }
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    dispatch(setCredentials({ token: "" }));
    const timer = setTimeout(() => {
      window.location.reload();
      clearTimeout(timer);
    }, 300);
  };
  return { loginStepOne, loginStepTwo, error, logout };
};
